export default {
  ordersOpened: 0
};
